import { render, staticRenderFns } from "./TestimoniList.vue?vue&type=template&id=7415ece2"
import script from "./TestimoniList.vue?vue&type=script&lang=js"
export * from "./TestimoniList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports